module.exports = __webpack_public_path__ + "media/images/application/template/logos/safe-contractor-logo-87fa3373e46e854e691680b0a98f543b.png";